export abstract class UserRoles {
  public static readonly VAULT_SUPER_ADMIN = 'vaultSuperAdmin';
  public static readonly VAULT_EDITOR = 'vaultEditor';
  public static readonly VAULT_CUSTOMER_ADMIN = 'vaultCustomerAdmin';
  public static readonly EXCHANGE_ADMIN = 'exchangeAdmin';
  public static readonly EXCHANGE_VENDOR = 'exchangeVendor';
  public static readonly EXCHANGE_VENDOR_PARTNER = 'exchangeVendorPartner';
}
